import { ENTERPRISE_CONTROL_BASE } from "../naturals-control/constants";

/** Naturals portal — Enterprise (franchise HQ) only. */
export const ENTERPRISE_ADMIN_BASE = "/nyafaz-naturals";
export const ENTERPRISE_PORTAL_CONSOLE_PATH = ENTERPRISE_CONTROL_BASE;

export const PORTAL_PRODUCTS = [
  {
    slug: "naturals",
    productType: "naturals",
    title: "Enterprise",
    subtitle: "Franchise networks & HQ",
    accent: "#2d5a7b",
    accentDark: "#234a66",
    adminPath: ENTERPRISE_ADMIN_BASE,
    consolePath: ENTERPRISE_CONTROL_BASE,
    nav: [
      { key: "overview", label: "Dashboard", path: "" },
      { key: "organizations", label: "Organizations", path: "organizations" },
    ],
  },
];

export const getProductBySlug = (slug) => PORTAL_PRODUCTS.find((p) => p.slug === slug) || null;

export const getProductByType = (productType) =>
  PORTAL_PRODUCTS.find((p) => p.productType === productType) || null;

export const productConsoleBase = (_slug) => ENTERPRISE_CONTROL_BASE;
